import { useEffect, useState } from 'react';
import qs from 'qs';
import getToken from '@/utils/token';

const prefixUrl = import.meta.env.VITE_GATEWAY_URL;

interface TakerMarketId {
  takerId: number;
  marketId: number;
}

interface DownloadInvoicesUrlArgs {
  makerOrganizationUuid: string;
  takerMarketIds: TakerMarketId[];
  currency: string;
  type: 'eligible' | 'ineligible' | 'adjustments';
}

// Download invoices used on Invoice Central page
const useDownloadInvoicesUrl = ({
  makerOrganizationUuid,
  takerMarketIds,
  currency,
  type,
}: DownloadInvoicesUrlArgs): string => {
  const token = getToken();
  const [invoiceDownloadUrl, setInvoiceDownloadUrl] = useState<string>('');

  const baseInvoiceDownloadUrl = `${prefixUrl}/api/c2fo/taker/maker/${makerOrganizationUuid}/invoices/${type}/csv`;

  useEffect(() => {
    const searchQuery = {
      takerMarketIds: JSON.stringify(takerMarketIds),
      currency,
    };

    setInvoiceDownloadUrl(`${baseInvoiceDownloadUrl}?token=${token}&${qs.stringify(searchQuery)}`);
  }, [baseInvoiceDownloadUrl, token, type, currency, takerMarketIds]);

  return invoiceDownloadUrl;
};

export default useDownloadInvoicesUrl;
